import { createFileRoute } from "@tanstack/react-router";
import { ReportPage } from "@/features/reports/ReportPage";

export const Route = createFileRoute("/_app/reports/$report")({ component: Page });

function Page() {
  const { report } = Route.useParams();
  return <ReportPage id={report} />;
}
